export enum SeaEventTypeInputEnum {
    AdjustHoursAfterTimeZoneChangeInput = 201,
    IDLCrossingInput = 199,
}
